<template>
  <section class="wrapper">
    <!--    <header>-->
    <!--      <div class="head">-->
    <!--        <a><img src="../../../static/img/04.png" alt="" /></a>-->
    <!--        <h2>文件中心</h2>-->
    <!--        <a href="javascript:;">已整理文件</a>-->
    <!--      </div>-->
    <!--    </header>-->
    <div class="conT">
      <div class="conBoth">
        <a href="javascript:;">
          <p>排序</p>
          <img src="../../../static/img/xsanj.png" alt=""/>
        </a>
        <a href="javascript:;">
          <p>格式</p>
          <img src="../../../static/img/xsanj.png" alt=""/>
        </a>
      </div>
    </div>
    <div class="conMain">
      <input type="file" accept="image/*" ref="file" id="f1"/>
      <van-grid>
        <van-grid-item @click="Import_camera()">
          <img src="../../assets/img/01.png" alt="" style="width:4rem">
          <h6 class="mt5 text-lightgray">拍照导入</h6>
        </van-grid-item>
        <van-grid-item @click="Import_photo()">
          <img src="../../assets/img/02.png" alt="" style="width:4rem">
          <h6 class="mt5 text-lightgray">相册导入</h6>
        </van-grid-item>
        <van-grid-item>
          <img src="../../assets/img/03.png" alt="" style="width:4rem">
          <h6 class="mt5 text-lightgray">邮件导入</h6>
        </van-grid-item>
        <van-grid-item>
          <img src="../../assets/img/05.png" alt="" style="width:4rem">
          <h6 class="mt5 text-lightgray">微信导入</h6>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="Cmain" v-for="(item,i) in CompanyList" :key="i">
      <a href="javascript:;" class="btn"></a>
      <li>
        <p>
          <img src="../../../static/img/photo.png" alt=""/>
        </p>
        <p>{{item.FileName}}<span>{{item.createDate}}</span></p>
        <a href="javasript:;" @click="T2('测试')">查看图片</a>
      </li>
    </div>
  </section>
</template>
<script>
  import {getImgListApi} from '@/api/document'

  export default {
    data() {
      return {
        files: '',
        C_Guid: '',
        CompanyList: []
      };
    },
    mounted: function () {
      this.getbothincoms();
    },
    methods: {
      Import_camera() {
        ///调用照相机事件
        //alert("第一次测试1");
        //import { MessageBox } from 'mint-ui';
        var _this = this;
        let data = new FormData();
        var files = document.getElementById("f1");


        if (files.files.length == 0) {
          alert("请点击选择文件后再选择此按钮");
        } else {
          data.append("C_Guid", sessionStorage.getItem('companyId'));
          data.append("frGuid", "");
          data.append('files', files.files[0]);

          _this.$axios.post("/fmsapi/common/UpLoadImg", data)
            .then((res) => {
              if (res.data.code === "000") {
                alert("提交成功");
                //location.replace(1);
                //alert(res.data.msg);
                window.location.reload();
              } else {
                //alert(res.data.msg);
                alert("提交失败");
              }
            })
            .catch((error) => {
              alert(error);
            });
        }
      },

      Import_photo() {
        var _this = this;
        let data = new FormData();
        var files = document.getElementById("f1");

        if (files.files.length == 0) {
          alert("请点击选择文件后再选择此按钮");
        } else {
          data.append("C_Guid", sessionStorage.getItem('companyId'));
          data.append("frGuid", "");
          data.append('files', files.files[0]);
          //data.append('TempFileNameFirst', '发票Post')
          //data.append('Type', 'Ocr')
          _this.$axios.post("/fmsapi/common/UpLoadImg", data)
            .then((res) => {
              if (res.data.code === "000") {
                alert("提交成功");
                //location.replace(1);
                //alert(res.data.msg);
                window.location.reload();
              } else {
                alert("提交失败");
              }
            })
            .catch((error) => {
              alert(error);
            });
        }
      },

      T2(A_GUID) {
        sessionStorage.setItem('imgGuid', A_GUID);
        this.$router.push('/GetImg')
      },

      async getbothincoms() {
        let params = {
          type: 1,
          C_GUID: this.getCookie().companyId,
          pageIndex: 1,
          pageSize: -1
        };
        let response = await getImgListApi(params);
        if (response.success) {
          this.CompanyList = response.result
        }
      }
    },
  }
</script>


<style lang="less" scoped>

  .conT {
    height: 0.4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #fbfafa;
  }

  .conBoth {
    width: 0.95rem;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-left: 0.1rem;
  }

  .conBoth a {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .conBoth a p {
    font-size: 0.12rem;
    color: #30302f;
    margin-right: 0.05rem;
  }

  .conBoth a img {
    width: 0.07rem;
    height: 0.05rem;
  }

  .conMain {
    height: 0.8rem;
    padding-top: 0.15rem;
    border-bottom: 0.05rem solid #f4f4f4;
  }

  .conMain ul {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .conMain ul li {
    width: 40%;
    height: 0.62rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.1rem;
    color: #8d8d8d;
  }

  .conMain ul li a img {
    width: 0.36rem;
    height: 0.36rem;
  }

  .Cmain {
    height: 0.63rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .btn {
    display: block;
    width: 0.15rem;
    height: 0.15rem;
    border: 1px solid #dddddc;
    border-radius: 50%;
  }

  .Cmain li {
    height: 0.63rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
  }

  .Cmain li p:first-child {
    width: 0.37rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cmain li p:first-child img {
    width: 0.25rem;
    height: 0.29rem;
  }

  .Cmain li p:nth-child(2) {
    width: 2.4rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 0.13rem;
    color: black;
  }

  .Cmain li p:nth-child(2) span {
    font-size: 0.09rem;
    color: #7d7d7d;
  }

  .Cmain li a {
    font-size: 0.12rem;
    color: #cbcbcb;
  }
</style>
